import { useMemo } from 'react';
import { SlashCommandList, renderCommandListDefault } from 'reactjs-tiptap-editor/slashcommand';
import { useLocale } from 'reactjs-tiptap-editor/locale-bundle';
import { RICH_TEXT_HEADING_LEVELS } from './rich-text-kit';

/** Library defaults the kit cannot execute: Video/Columns extensions are not loaded, headings stop at h3. */
const UNSUPPORTED = new Set([
  'video',
  'columns',
  ...[1, 2, 3, 4, 5, 6].filter((level) => !RICH_TEXT_HEADING_LEVELS.includes(level)).map((level) => `heading${level}`),
]);

/**
 * Feeds the `/` menu. The library keeps the command list in a global store that is
 * only populated while this component is mounted, so every editor that loads the
 * `SlashCommand` extension must render it inside its `RichTextProvider`.
 */
export default function RichTextSlashMenu() {
  const { t } = useLocale();
  const commandList = useMemo(
    () =>
      renderCommandListDefault({ t }).map((group) => ({
        ...group,
        commands: group.commands.filter((command) => !UNSUPPORTED.has(command.name)),
      })),
    [t],
  );
  return <SlashCommandList commandList={commandList} />;
}
